/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface KlaviyoList
 */
export interface KlaviyoList {
  /**
   *
   * @type {string}
   * @memberof KlaviyoList
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof KlaviyoList
   */
  name: string;
}

/**
 * Check if a given object implements the KlaviyoList interface.
 */
export function instanceOfKlaviyoList(value: object): value is KlaviyoList {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function KlaviyoListFromJSON(json: any): KlaviyoList {
  return KlaviyoListFromJSONTyped(json, false);
}

export function KlaviyoListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): KlaviyoList {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function KlaviyoListToJSON(json: any): KlaviyoList {
  return KlaviyoListToJSONTyped(json, false);
}

export function KlaviyoListToJSONTyped(
  value?: KlaviyoList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
  };
}
